import { useAuth } from '@/contexts/auth-context';
import { NoticePanel, ThemedButton } from '@fluenceur/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LegalAcceptanceModal } from './LegalAcceptanceModal';
import { LEGAL_DOCUMENT_LABELS, pendingLegalDocuments } from './pending-legal-documents';

/** General legal updates never block the dashboard or a billing action. */
export function LegalAcceptanceBanner() {
  const { user } = useAuth();
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  if (!user?.requiresLegalAcceptance) return null;
  const documents = pendingLegalDocuments(user)
    .map((type) => t(LEGAL_DOCUMENT_LABELS[type]))
    .join(' · ');

  return (
    <>
      <NoticePanel
        tone="info"
        hideIndicator
        title={t('legal.acceptance.notice', { documents })}
        m={0}
        w="full"
        borderRadius={0}
        py={1.5}
        gap={2}
        actions={
          <ThemedButton
            variant="secondary"
            size="xs"
            w={{ base: 'full', sm: 'auto' }}
            onClick={() => setIsOpen(true)}
          >
            {t('legal.acceptance.read')}
          </ThemedButton>
        }
      />
      {isOpen ? <LegalAcceptanceModal isOpen onClose={() => setIsOpen(false)} /> : null}
    </>
  );
}
